import { NgModule } from '@angular/core';
import { Ga4GgProductPageEventBuilder } from './ga4-gg-product-page-event.builder';

@NgModule({})
export class Ga4GgProductPageEventModule {
  constructor(_ga4GgProductPageEventBuilder: Ga4GgProductPageEventBuilder) {}
}
